import { MVTLayer } from '@deck.gl/geo-layers'

class CustomMVTLayer extends MVTLayer {
  updateState (info) {
    super.updateState(info)
    const flags = info.changeFlags
    if (flags.propsChanged || flags.updateTriggersChanged) {
      this.state.tileset.tiles.forEach(tile => {
        tile.layers = null
      })
    }
  }
}

CustomMVTLayer.layerName = 'CustomMVTLayer'
CustomMVTLayer.defaultProps = MVTLayer.defaultProps

export default CustomMVTLayer
